import { masks } from 'common/constants';

export const getZipCodeMask = (code: string) => {
  const unmaskedValue = code.replace(/-/g, '');

  return unmaskedValue.length > masks.ZIP_CODE_SHORT.length ? masks.ZIP_CODE : masks.ZIP_CODE_SHORT;
};
